module.exports = __webpack_public_path__ + "img/pick3.13b7cf1c.png";